<template lang="html">
  <masked-input
    type="text"
    class="text-left form-control"
    :class="['is-' + state]"
    :id="id"
    v-model="phone"
    @change="callChange"
    @keyup="callKeyUp"
    :placeholder="this.placeholder"
    :mask="digitMask"
    :guide="false"
  ></masked-input>
</template>

<script>
import MaskedInput from 'vue-text-mask';

export default {
  name: 'InputPhone',
  components: {
    MaskedInput,
  },
  props: {
    placeholder: {
      type: String,
      default: 'Celular',
    },
    model: {
      required: true,
      default: null,
    },
    id: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    phone: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit('update:model', val);
      },
    },
  },
  mounted() {
    this.phone = this.model;
  },
  watch: {
    phone(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      this.$emit('input', newVal);
    },
  },
  methods: {
    callChange(e) {
      this.$emit('change', e.target.value);
      this.onChange(this.model);
    },
    callKeyUp() {
      this.onKeyup(this.model);
    },
    digitMask(rawValue) {
      const allowed = /[0-9()\s-]/;
      return rawValue
        .split('')
        .map(() => allowed);
    },
  },
};
</script>
